<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header">{{associatedDocument.titleHeader}}</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <p class="common-modal__content-header-info common-modal__content-header-info--one-row">
      <span>
        {{('common.state' |afTranslate)}}:
      </span>
      <span>{{process?.name}}</span>
    </p>
    <div class="associated-documentation__table-container"
      id="associated-documentation">
      <div class="common-table-header__container">
        <div class="common-table-body__inner-row-space-between w-[calc(100%-30px)]">
          <div class="common-table-cell__container w-[60px]">
            <filter-by-list-and-order
              [item]="associatedDocument.extensionFilter"
              [list]="associatedDocument.extensionList"
              (launchActionFilterOrderEmit)="filterOrder($event, 'extension')">
            </filter-by-list-and-order>
          </div>
          <div class="common-table-cell__container w-[320px]">
            <filter-by-search-and-order
              [item]="associatedDocument.nameFilter"
              [filterOrder]="associatedDocument.order"
              [order]="associatedDocument.orderCreation"
              (launchActionFilterOrderEmit)="filterOrder($event, 'name')">
            </filter-by-search-and-order>
          </div>
          <div class="common-table-cell__container w-[100px]">
            <filter-by-list-and-order
              [item]="associatedDocument.createdByFilter"
              [list]="associatedDocument.createdByList"
              (launchActionFilterOrderEmit)="filterOrder($event, 'createdBy')">
            </filter-by-list-and-order>
          </div>
          <div class="common-table-cell__container w-[180px]">
            <filter-by-order
              [item]="associatedDocument.createdFilter"
              [filterOrder]="associatedDocument.order"
              [order]="associatedDocument.orderCreation"
              (launchActionFilterOrderEmit)="filterOrder($event, 'created')">
            </filter-by-order>
          </div>
        </div>
        <div class="common-table-cell__container w-[30px]"></div>
      </div>
      @if(!associatedDocument.searchingDocuments){
        @for (document of associatedDocument.filterDocumentationList | afOrderBy:associatedDocument.order:associatedDocument.orderCreation; track $index) {
          <div class="common-table-body__row">
            <div class="common-table-body__inner-row-space-between w-[calc(100%-30px)]"
              (click)="launchAction('view', document)">
              <div class="common-table-cell__container-center w-[60px]">
                <span [class]="'common-icon__md ' + (document.extension | extensionDocument:'md')"></span>
              </div>
              <div class="common-table-cell__container w-[320px]">
                <span-tooltip class="common-table-cell__standard-text-label"
                  [text]="document.name">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[100px]">
                <span-tooltip class="common-table-cell__standard-text-label"
                  [text]="document.createdBy">
                </span-tooltip>
              </div>
              <div class="common-table-cell__container w-[180px]">
                <span-tooltip class="common-table-cell__standard-text-label"
                  [text]="document.created | convertDate:'without-time'">
                </span-tooltip>
              </div>
            </div>
            <div class="common-table-cell__container w-[30px] common-table__menu-options">
              <button-with-menu-action
                [item]="document"
                (configureMenuEmitter)="openDocumentationMenu(document)"
                (launchActionEmitter)="launchAction($event.action, document)"></button-with-menu-action>
            </div>
          </div>
        }
        <div class="pagination-control">
          <div class="pagination-control__container-pagination">
            <div class="pagination-control__container-text-pagination">
              <span class="pagination-control__text-pagination-bold">
                <span [afTranslate]="'common.total'">_Total</span>:
                <span>{{associatedDocument.filterDocumentationList.length}}</span>
              </span>
            </div>
          </div>
        </div>
      }@else{
        <div class="associated-documentation__table-row-container">
          <div class="associated-documentation__spinner-container">
            <p-progressSpinner styleClass="common-spinner__progress-container-color-XL"
                ariaLabel="loading">
            </p-progressSpinner>
          </div>
        </div>
      }
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.close'"></span>
    </button>
  </div>
</div>
